export default class Fonts {
	public static get DefaultFont(): string {
		return "arial";
	}

	public static get Arial(): string {
		return "arial";
	}

	public static get MontserratBold(): string {
		return "montserrat-bold";
	}

	public static get MontserratExtraBold(): string {
		return "montserrat-extrabold";
	}
}
